import { HttpClient, HttpDownloadProgressEvent } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { UserService } from 'src/app/_services/users/user.service';
import { MarkedPipe } from 'src/app/_shared/pipes/marked.pipe';
import { IApiService } from 'src/app/chat-ai/models/chat-ai.models';
import { ChatAiStorageService } from 'src/app/chat-ai/services/storage/chat-ai-storage.service';

export const baseUrl = 'agent-router'; // microserviceKey + pathPrefix

@Injectable()
export class ChatAiServerApiService implements IApiService {
    constructor(
        private http: HttpClient,
        private chatAiStorageService: ChatAiStorageService,
        private userService: UserService,
        private markedPipe: MarkedPipe
    ) {}

    getBotResponse(text: string): Observable<string> {
        return this.http
            .post(
                `${baseUrl}/agent`,
                {
                    message: text,
                    thread_id: this.chatAiStorageService.getSessionUUID(),
                    solidus_client: this.userService.user.solidusClientId
                },
                { responseType: 'text', observe: 'events', reportProgress: true }
            )
            .pipe(map((response: HttpDownloadProgressEvent) => this.markedPipe.transform(response.partialText)));
    }
}
